import { z } from 'zod'

import { UnitOccupancyStatusEnum } from '@/models'

/** The PMS occupancy statuses plus 'all', which only ever exists as a UI tab. */
export const UnitOccupancyTabEnum = z.enum([...UnitOccupancyStatusEnum.options, 'all'])
export type UnitOccupancyTab = z.infer<typeof UnitOccupancyTabEnum>
